import "./App.css";
import CalcFare from "./components/CalcFare";

function App() {
  return (
    <div className="App">
      <CalcFare />
    </div>
  );
}

export default App;
